import { format } from 'date-fns'
import { getUTCDate } from './getDateFromTimeIso'

const getDatetimeForVectorTiles = datetime => {
  const utcDatetime = getUTCDate(datetime)
  const vectorDatetime = format(utcDatetime, 'YYY-MM-dd HH:mm:ss.SSS000+00:00')

  return vectorDatetime
}

export default getDatetimeForVectorTiles



// WEBPACK FOOTER //
// ./src/utility/getDatetimeForVectorTiles.js